import { ref, reactive } from "vue";
import type { Client, Subscription } from "webstomp-client";

// Module-level state shared across all RequestBodyView component instances
// Using a reactive object to avoid eslint's import/no-mutable-exports rule

interface JoltState {
  joltClient: Client | null;
  joltSubscription: Subscription | null;
  currentTransformationId: string | null;
  activeComponentId: string | null;
  isJoltOperationInProgress: boolean;
  pendingTransformationLookup: boolean;
  messageBuffer: any[];
  pollingTimeoutId: any;
  pendingGenerate: boolean;
  pendingResume: boolean;
}

export const JOLT_MESSAGE_BUFFER_CAP = 20;

export const joltState = reactive<JoltState>({
  joltClient: null,
  joltSubscription: null,
  currentTransformationId: null,
  activeComponentId: null,
  isJoltOperationInProgress: false,
  pendingTransformationLookup: false,
  messageBuffer: [],
  pollingTimeoutId: null,
  pendingGenerate: false,
  pendingResume: false,
});

export const pendingJoltResult = ref<{ joltSpec: string } | null>(null);

export function pushJoltMessageToBuffer(message: any): void {
  if (joltState.messageBuffer.length >= JOLT_MESSAGE_BUFFER_CAP) {
    joltState.messageBuffer.shift();
  }
  joltState.messageBuffer.push(message);
}

export function resetJoltLookupState(): void {
  joltState.pendingTransformationLookup = false;
  joltState.messageBuffer.splice(0);
  if (joltState.pollingTimeoutId !== null) {
    clearTimeout(joltState.pollingTimeoutId);
    joltState.pollingTimeoutId = null;
  }
}
